import { api as classroomApi } from './auto-generated/classroom'

classroomApi.enhanceEndpoints({
  endpoints: {
    classroomCreateClassroom: {
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        let patchResult
        try {
          const { data } = await queryFulfilled
          patchResult = dispatch(
            classroomApi.util.updateQueryData(
              'classroomGetCurrentClassroom',
              undefined,
              (draft) => {
                draft = data
                return draft
              },
            ),
          )
        } catch {
          patchResult?.undo()
        }
      },
    },
    classroomJoinClassroom: {
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled
          dispatch(classroomApi.endpoints.classroomGetCurrentClassroom.initiate())
        } catch {}
      },
    },
    classroomUnjoinClassroom: {
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled
          dispatch(classroomApi.endpoints.classroomGetCurrentClassroom.initiate())
        } catch {}
      },
    },
    classroomCreateClassroomTask: {
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          const { data: newTask } = await queryFulfilled
          if (newTask.folders.length === 0) {
            dispatch(
              classroomApi.util.updateQueryData(
                'classroomListClassroomTasks',
                { classroomId: newTask.classroom.id },
                (draftTasks) => {
                  console.log('draftTasks', JSON.stringify(draftTasks))
                  draftTasks.push(newTask)
                },
              ),
            )
          }
          if (newTask.folders.length !== 0) {
            dispatch(
              classroomApi.util.updateQueryData(
                'classroomGetTeacherTaskFolders',
                undefined,
                (draftFolders) => {
                  draftFolders.map((folder) => {
                    if (folder.id === newTask.folders[0].id) {
                      folder.tasks.push(newTask)
                    }
                  })
                },
              ),
            )
          }
        } catch {}
      },
    },
    classroomDeleteClassroomTask: {
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        let patchResult
        try {
          const { data: deleted_task } = await queryFulfilled
          patchResult = dispatch(
            classroomApi.util.updateQueryData(
              'classroomListClassroomTasks',
              { classroomId: deleted_task.classroom_id },
              (draftTasks) => {
                return draftTasks?.filter((item) => item?.id !== args?.taskId)
              },
            ),
          )
        } catch {
          patchResult?.undo()
        }
      },
    },
    classroomUpdateClassroomTask: {
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        let patchResult
        try {
          const { data: updatedTask } = await queryFulfilled
          patchResult = dispatch(
            classroomApi.util.updateQueryData(
              'classroomListClassroomTasks',
              { classroomId: updatedTask.classroom_id },
              (draftTasks) => {
                return draftTasks.map((item) => {
                  if (item?.id === args?.taskId) {
                    return updatedTask
                  } else {
                    return item
                  }
                })
              },
            ),
          )
        } catch {
          patchResult?.undo()
        }
      },
    },
    classroomAddIspeakTaskToClassroomTasks: {
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          const { data: newTask } = await queryFulfilled
          dispatch(
            classroomApi.util.updateQueryData(
              'classroomListClassroomTasks',
              { classroomId: newTask.classroom.id },
              (draftTasks) => {
                draftTasks.push(newTask)
              },
            ),
          )
        } catch {}
      },
    },
    classroomAddTasksFolder: {
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          const { data: newFolder } = await queryFulfilled
          dispatch(
            classroomApi.util.updateQueryData(
              'classroomGetTeacherTaskFolders',
              undefined,
              (draftFolders) => {
                draftFolders.push(newFolder)
              },
            ),
          )
        } catch {}
      },
    },
    classroomDeleteClassroomTasksFolder: {
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        let patchResult
        try {
          const { data: deleted_folder } = await queryFulfilled
          patchResult = dispatch(
            classroomApi.util.updateQueryData(
              'classroomGetTeacherTaskFolders',
              undefined,
              (draftFolders) => {
                return draftFolders?.filter((item) => item?.id !== args?.folderId)
              },
            ),
          )
        } catch {
          patchResult?.undo()
        }
      },
    },
    // classroomUpdateClassroomTasksFolder: {
    //   async onQueryStarted(args, { dispatch, queryFulfilled }) {
    //     let patchResult
    //     try {
    //       const { data: updatedFolder } = await queryFulfilled
    //       patchResult = dispatch(
    //         classroomApi.util.updateQueryData(
    //           'classroomGetTeacherTaskFolders',
    //           undefined,
    //           (draftFolders) => {
    //             return draftFolders.map((item) => {
    //               if (item?.id === updatedFolder.id) {
    //                 return updatedFolder
    //               } else {
    //                 return item
    //               }
    //             })
    //           },
    //         ),
    //       )
    //     } catch {
    //       patchResult?.undo()
    //     }
    //   },
    // },
  },
})

export { classroomApi }
